import router from './router'
import voluntaryMessages from './localization'

export default {
  router,
  localization: voluntaryMessages,
}
